module.exports = __webpack_public_path__ + "static/IMG_7544-2aa1f63db013a8124dd84191de95eff1.jpg";